
export const appValidation = function (data) {
    const formErrors = [];

    if (data.appKey !== 'undefined') {
        if (data.appKey === '') {
            formErrors['appKey'] = true;
        }
    }

    return formErrors;
}
